import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Fragment, useRef } from 'react';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import GuideVideo from './GuideVideo';

const GuideVideoModal = ({ isOpen, onClose }: { isOpen: boolean, onClose?: () => void}) => {
    const [isFullScreen, setIsFullScreen] = useState(false);

    const toggleFullscreen = () => {
        setIsFullScreen(!isFullScreen)
    };

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-[1001]" onClose={() => { }}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-50 " />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className={`${isFullScreen ? 'md:w-[1440px] w-full items-center justify-center flex bg-[#ffffff00]':'bg-[#ffffff00]  md:w-[1000px] w-[360px]' }  transition-all  duration-500  aspect-video `}>
                                <GuideVideo onClose={onClose} toggleFullscreen={toggleFullscreen} isFullScreen={isFullScreen} />
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition >)
}
export default GuideVideoModal
